import {
  put,
  take,
} from 'redux-saga/effects';
import {
  AUTO_SIGNIN_SUCCESS,
  autoSignin,
} from '../../../../../actions/signin';
import { setProfilePageContext } from '../../../../../actions/profile-completion';
import { JUST_SIGNED_UP_CONTEXT } from '../../../../../context';

export function* userAccountCreationStep({ flow, authCredentials }) {
  yield put(autoSignin({
    ...authCredentials,
    flow,
    authFlow: 'signup',
  }));
  yield take(AUTO_SIGNIN_SUCCESS);
  yield put(setProfilePageContext(JUST_SIGNED_UP_CONTEXT));
  return { flavor: authCredentials?.flavor };
}
